import { Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { DEFAULT_ADMISSION_TYPE, GUTTOR_SPACE, KSRTC_ADMISSION_TYPE } from '../../../../../../../shared/constants/commonConstants';
import {
  ADENOTONSILLECTOMY_DIAGNOSIS_TYPE,
  Appendicectomy_DIAGNOSIS_TYPE,
  CATARACT_DIAGNOSIS_TYPE, CATARACT_EYE_TYPE_ICD_MAPPING, Cholecystectomy_DIAGNOSIS_TYPE,
  DEFAULT_OPTIONS_FOR_APPROACH,
  DEFAULT_OPTIONS_FOR_POSITION,
  DIALYSIS_DIAGNOSIS_TYPE, formInputStates, Haemorrhoidectomy_DIAGNOSIS_TYPE, HYSTERECTOMY_DIAGNOSIS_TYPE,
  MATERNITY_DIAGNOSIS_TYPE,
  OTHER_ID,
  URSwithDJ_DIAGNOSIS_TYPE,
} from '../../../../../../../shared/constants/crmConstants';
import { useFindPayer } from '../../../../../../../shared/hooks/useFindPayer';
import { useForceUpdate } from '../../../../../../../shared/hooks/useForceUpdate';
import { useSetFormControlConfig } from '../../../../../../../shared/hooks/useSetFormControlConfig';
import { RootState } from '../../../../../../../store';
import { dialysisValidation, findKeyValuePair, getIsPageNameDetail,
  handleUserFocus, isValidStayLength } from '../../../../service/crmUtils';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../../config/formControlConfig';
import { intersection } from 'lodash';
import FormInputNumber from '../../../../../../../shared/components/crmFormElement/FormInputNumber/FormInputNumber';
import MaternityCard from '../MaternityCard/MaternityCard';
import FormSelect from '../../../../../../../shared/components/crmFormElement/FormSelect/FormSelect';
import { FormInputDate, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import {isAfter, isSameDay} from 'date-fns';

const AutomatedOtherTreatmentDetailCard = ({ form, isLoading, location: { pathname } }: any): ReactElement | null => {
  const [claimDetailBackup, setClaimDetailBackup] = useState<any>({});
  const [selectedDiagnosisId, setSelectedDiagnosisId] = useState([]);
  const stayLength = form.getFieldValue(['stayLength']);
  const {
    payerLookUp = {}, payerList: { payer: { uniqueIdentifier, name, isRpaPayer } },
    newAdmission: { cardCollapse: { selectedDiagnosisIds }, proposedLineTreatmentId, hospitalizationDuration,
    },
    admissionDetails: { claimDetails: claimDetail = {} },
  } = useSelector((state: RootState): RootState => state);
  const [inputStates, setInputStates] = useState(formInputStates.automatedOtherTreatmentDetailForm);

  let payerName = name;
  const findPayer = useFindPayer();
  if (claimDetail && !payerName) {
    const { payerId } = claimDetail;
    payerName = findPayer(payerId);
  }
  // const { memberAge }: any = selectedBeneficiaryDetail || {};
  // const { patientAge } = claimDetail;

  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[payerName];

  let formElementCount: any[] = [];
  let dialysisValidationCount: any[] = [];
  let dialysisValidationNumber = 0;

  let isRpa = false;
  let showAdmissionTypeForKsrtc = false;
  let automatedOtherFieldsBasedOnICD = false;
  let hideFields = false;
  if (payerConfig) {
    const payerConfigValues = Object.values(payerConfig);
    formElementCount = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'treatment' && !hidden);
    dialysisValidationCount = payerConfigValues?.filter(({ maximumLimitDialysis, hidden }: any): boolean =>
    maximumLimitDialysis !== undefined && !hidden);
    const dialysisValidationObject = dialysisValidationCount[0];
    dialysisValidationNumber = dialysisValidationObject?.['maximumLimitDialysis'] ?
    dialysisValidationObject['maximumLimitDialysis'] : undefined;
    if (hospitalizationDuration !== undefined && hospitalizationDuration < dialysisValidationNumber) {
      dialysisValidationNumber = hospitalizationDuration;
    }
    isRpa = !!(payerConfigValues.filter(({ type, hidden }: any): boolean => type === 'RPA' && !hidden)?.length);
    automatedOtherFieldsBasedOnICD =  Boolean(payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'automatedOtherFieldsBasedOnICD' && !hidden)?.length);
    showAdmissionTypeForKsrtc = payerConfigValues?.some(
      ({ showAdmissionType, hidden }: any): any => showAdmissionType && !hidden,
    );
    hideFields = payerConfigValues.some(({ hideField }: any): boolean => hideField);
  }

  const forceUpdate = useForceUpdate();
  const getValueBasedOnConfig = useSetFormControlConfig();
  const [specialityData, setSpecialityData] = useState<any>([]);
  const icdCodes = form.getFieldValue(['icd10'])?.toString();
  const icdCodesValues = icdCodes?.split(',') //  there is a diagnosis entered with related icd
  ?.map((code: string): string => code?.trim());
  useEffect((): void => {
    if (claimDetail && Object?.keys(claimDetail)?.length) {
      const isPageNameDetail = getIsPageNameDetail(pathname);
      const { cataract, dialysis, admissionType, position, eye,
      treatmentApproach } = claimDetail || {};
      const { ailmentid: cataractType, lenseId: contactLensType } = cataract || {};
      let formValue: any = { admissionType, position, eye, treatmentApproach, rpaAdmissionType: admissionType };

      if (dialysis?.dialysis) {
        formValue = {
          ...formValue,
          dialysis: dialysis?.dialysis,
        };
      }
      if (cataractType) {
        formValue = {
          ...formValue,
          cataractType: isPageNameDetail ? cataractType : parseInt(cataractType, 10),
        };
      }
      if (contactLensType) {
        formValue = {
          ...formValue,
          contactLensType: isPageNameDetail ? contactLensType : parseInt(contactLensType, 10),
        };
      }

      const updatedFormValues = getValueBasedOnConfig(isPageNameDetail, formValue);
      setClaimDetailBackup(updatedFormValues);
      form.setFieldsValue(updatedFormValues);
      forceUpdate();
    }
  }, [claimDetail]);

  useEffect((): void => {
    if (!getIsPageNameDetail(pathname)) {
      const { automatedProcedure } = form.getFieldsValue(['automatedProcedure']);
      if (automatedProcedure && automatedProcedure !== OTHER_ID) {
        const { icdCode } = findKeyValuePair(payerLookUp[uniqueIdentifier]?.automationProcedures, 'id', automatedProcedure) || {};
        setSelectedDiagnosisId(icdCode);
      } else {
        setSelectedDiagnosisId([]);
      }
    } else {
      const { automatedProcedure } = claimDetail;
      const { icdCode } = findKeyValuePair(
        payerLookUp[uniqueIdentifier]?.automationProcedures, 'maMappedProcedure', automatedProcedure,
      ) || {};
      setSelectedDiagnosisId(icdCode || []);
    }

  }, [selectedDiagnosisIds]);

  useEffect((): void => {
     if (payerLookUp[uniqueIdentifier]?.speciality?.length > 0) {
      const filteredspecialityData = payerLookUp[uniqueIdentifier]?.speciality?.filter((ele: any): boolean =>
       (ele.payerParentId === Number(proposedLineTreatmentId)));
      setSpecialityData(filteredspecialityData);
     }
  }, [proposedLineTreatmentId]);

  useEffect((): void => {
    if (hospitalizationDuration > 0 && form?.getFieldsValue(['dialysis'])) {
      form?.validateFields(['dialysis']);   // validate dialysis field if already entered and the duration changes
    }
  }, [hospitalizationDuration]);

  const commonDetail = { isLoading, form, claimDetailBackup };

  const hasShowFormElement = (diagnosisId: string[], hideFieldsCheck?: boolean): boolean => {
    if (hideFieldsCheck) {
      return true;
    }
    if (automatedOtherFieldsBasedOnICD) { // Only for hdfc to show extra fields even if automated procedure is not selected and
      const icdsToCheck = selectedDiagnosisId?.length ? selectedDiagnosisId : icdCodesValues;
      return !intersection(icdsToCheck, diagnosisId)?.length;
    } else {
      return !intersection(selectedDiagnosisId, diagnosisId)?.length;
    }
  };

  const getOptionsBasedOnIcd = (dataObject: any): any[] => {
    if (automatedOtherFieldsBasedOnICD) { // ONLY FOR HDFC
      const result = Object?.keys(dataObject)
        ?.filter((key: string): string => icdCodesValues?.includes(key))
        ?.reduce((acc: any, key: string): any => acc?.concat(dataObject[key]), []);
      return result || [];
    } else {
      const dataObjectKey: string = selectedDiagnosisId?.[0] || '';
      const data = dataObjectKey?.length > 0 ? dataObject[dataObjectKey] : [];
      return data || [];
    }
  };

  const onEyeChange = (selectedEye: any): any => {
    if (CATARACT_EYE_TYPE_ICD_MAPPING[selectedEye]) {
      form.setFieldsValue({ icd10: CATARACT_EYE_TYPE_ICD_MAPPING[selectedEye] });
    }
  };

  useEffect((): void => {
    const dateOfDiagnosis = form.getFieldValue('dateOfDiagnosis');
    if (isAfter(new Date(dateOfDiagnosis), new Date(stayLength?.[0]))) {
      form.resetFields(['dateOfDiagnosis']);
    }
  }, [stayLength]);

  const disabledDateOfDiagnosis = (current: any): any => {
    current = new Date(current);
    const today = new Date();
    if (!stayLength?.[0] || !isValidStayLength(stayLength) || isAfter(current, today)) {
      return true;
    }
    const stayStartDate = new Date(stayLength?.[0]);
    return isAfter(current, stayStartDate) && !isSameDay(current, stayStartDate);
  };

  const anesthesiaOptions = ['General', 'Local', 'Regional', 'Spinal'];

  return (
    (formElementCount?.length || isRpaPayer) ?
      <Row gutter={GUTTOR_SPACE} data-testid="other-treatment-detail">
        <FormSelect detail={{
          ...commonDetail,
          key: 'eye',
          options: Object.keys(CATARACT_EYE_TYPE_ICD_MAPPING),
          size: 12,
          required: true,
          hidden: hasShowFormElement(CATARACT_DIAGNOSIS_TYPE, hideFields),
          onChange: onEyeChange,
          onFocus: (): void => handleUserFocus('eye', setInputStates, true),
          onBlur: (): void => handleUserFocus('eye', setInputStates, false),
          isShowSuggestedValue: inputStates.eye.isShowSuggestedValue,
        }} />
        <FormSelect detail={{
          ...commonDetail,
          key: 'treatmentApproach',
          options: getOptionsBasedOnIcd(DEFAULT_OPTIONS_FOR_APPROACH),
          size: 12,
          required: true,
          hidden: hasShowFormElement(CATARACT_DIAGNOSIS_TYPE.concat(
            HYSTERECTOMY_DIAGNOSIS_TYPE,
            ADENOTONSILLECTOMY_DIAGNOSIS_TYPE,
            Haemorrhoidectomy_DIAGNOSIS_TYPE,
          ), hideFields),
          onFocus: (): void => handleUserFocus('treatmentApproach', setInputStates, true),
          onBlur: (): void => handleUserFocus('treatmentApproach', setInputStates, false),
          isShowSuggestedValue: inputStates.treatmentApproach.isShowSuggestedValue,
        }} />
        <FormInputNumber detail={{
          ...commonDetail,
          key: 'dialysis',
          size: 12,
          required: true,
          hidden: hasShowFormElement(DIALYSIS_DIAGNOSIS_TYPE),
          noOfDecimalAllowed: 0,
          rules: [ dialysisValidation(dialysisValidationNumber)],
        }}
        />
        <FormSelect detail={{
          ...commonDetail,
          key: 'position',
          options: getOptionsBasedOnIcd(DEFAULT_OPTIONS_FOR_POSITION),
          size: 12,
          required: true,
          hidden: hasShowFormElement(HYSTERECTOMY_DIAGNOSIS_TYPE.concat(
            HYSTERECTOMY_DIAGNOSIS_TYPE,
            URSwithDJ_DIAGNOSIS_TYPE,
          ), hideFields),
        }} />
        <MaternityCard form={form} isLoading={isLoading} />
        <FormSelect detail={{
          ...commonDetail,
          key: 'admissionType',
          size: 12,
          allowClear: true,
          options: showAdmissionTypeForKsrtc ? KSRTC_ADMISSION_TYPE : DEFAULT_ADMISSION_TYPE,
          hidden: showAdmissionTypeForKsrtc ? !showAdmissionTypeForKsrtc : (hasShowFormElement(HYSTERECTOMY_DIAGNOSIS_TYPE.concat(
            MATERNITY_DIAGNOSIS_TYPE,
            Appendicectomy_DIAGNOSIS_TYPE,
            Cholecystectomy_DIAGNOSIS_TYPE,
            URSwithDJ_DIAGNOSIS_TYPE,
          )) || isRpa),
          onFocus: (): void => handleUserFocus('admissionType', setInputStates, true ),
          onBlur: (): void => handleUserFocus('admissionType', setInputStates, false ),
          isShowSuggestedValue: inputStates.admissionType.isShowSuggestedValue,
        }}
        />
        <FormSelect detail={{
          ...commonDetail,
          key: 'rpaAdmissionType',
          size: 12,
          allowClear: true,
          required: true,
          options: (payerLookUp[uniqueIdentifier]?.admission_type || []),
          hidden: !isRpa,
          onFocus: (): void => handleUserFocus('rpaAdmissionType', setInputStates, true ),
          onBlur: (): void => handleUserFocus('rpaAdmissionType', setInputStates, false ),
          isShowSuggestedValue: inputStates.rpaAdmissionType.isShowSuggestedValue,
        }} />
        <FormSelect detail={{
          ...commonDetail,
          key: 'lossType',
          size: 12,
          allowClear: true,
          required: true,
          options: ['Illness', 'Accident'],
          onFocus: (): void => handleUserFocus('lossType', setInputStates, true ),
          onBlur: (): void => handleUserFocus('lossType', setInputStates, false ),
          isShowSuggestedValue: inputStates.lossType.isShowSuggestedValue,
        }}
        />
        <FormInputDate detail={{
          ...commonDetail,
          key: 'dateOfDiagnosis',
          size: 12,
          disabledDate: disabledDateOfDiagnosis,
          onFocus: (): void => handleUserFocus('dateOfDiagnosis', setInputStates, true ),
          onBlur: (): void => handleUserFocus('dateOfDiagnosis', setInputStates, false ),
          isShowSuggestedValue: inputStates.dateOfDiagnosis.isShowSuggestedValue,
        }} />
        <FormSelect detail={{
          ...commonDetail,
          key: 'speciality',
          size: 12,
          options: specialityData.length > 0 ? specialityData : (payerLookUp[uniqueIdentifier]?.speciality || []),
        }} />
        <FormTextInput detail={{
          ...commonDetail,
          key: 'routeOfAdministrationText',
          size: 12,
          onFocus: (): void => handleUserFocus('routeOfAdministrationText', setInputStates, true ),
          onBlur: (): void => handleUserFocus('routeOfAdministrationText', setInputStates, false ),
          isShowSuggestedValue: inputStates.routeOfAdministrationText.isShowSuggestedValue,
        }} />
        <FormTextInput detail={{
          ...commonDetail,
          key: 'investigationDetails',
          size: 12,
        }} />
        <FormInputNumber detail={{
          ...commonDetail,
          key: 'hypertensionMonths',
          size: 12,
        }} />
        <FormInputNumber detail={{
          ...commonDetail,
          key: 'diabetesMonths',
          size: 12,
        }} />
        <FormInputNumber detail={{
          ...commonDetail,
          key: 'estimatedDays',
          size: 12,
        }} />
        <FormInputNumber detail={{
          ...commonDetail,
          key: 'ailmentDuration',
          size: 12,
        }} />
        <FormSelect detail={{
          ...commonDetail,
          key: 'anesthesiaType',
          size: 12,
          options: anesthesiaOptions,
        }} />
      </Row> : null
  );
};

export default withRouter(AutomatedOtherTreatmentDetailCard);
